var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.953 7.977"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 460",
    d: "M12.539 1.415L6.977 6.977 1.415 1.415",
    fill: "none",
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}

export default __webpack_public_path__ + "ab65ba123437ec9096ced875de645192.svg";
export { SvgChevronDown as ReactComponent };